import React from 'react';
import PropTypes from 'prop-types';
import { ApiDateType } from 'types/CommonTypes';
import MeasurementEditPage from 'Measurement/Edit/MeasurementEditPage';
import MeasurementFetchByDateConnectorApollo from 'Measurement/MeasurementByDate/Connector/Apollo/MeasurementFetchByDateConnectorApollo';
import MeasurementSaveByDateConnectorApollo from 'Measurement/MeasurementByDate/Connector/Apollo/MeasurementSaveByDateConnectorApollo';
import MeasurementDeleteByDateConnectorApollo from 'Measurement/MeasurementByDate/Connector/Apollo/MeasurementDeleteByDateConnectorApollo';

const MeasurementEditRoute = props => (
    <MeasurementFetchByDateConnectorApollo date={props.match.params.date}>
        {fetchData => (
            <MeasurementSaveByDateConnectorApollo {...fetchData}>
                {saveData => (
                    <MeasurementDeleteByDateConnectorApollo {...saveData}>
                        {deleteData => (
                            <MeasurementEditPage
                                {...fetchData}
                                {...saveData}
                                {...deleteData}
                            />
                        )}
                    </MeasurementDeleteByDateConnectorApollo>
                )}
            </MeasurementSaveByDateConnectorApollo>
        )}
    </MeasurementFetchByDateConnectorApollo>
);
MeasurementEditRoute.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            date: ApiDateType,
        }).isRequired,
    }).isRequired,
};

export default MeasurementEditRoute;
